<template>
    <div v-loading="loading" class="card-deal">
        <div class="card-deal-header caption-block">
            <div class="title">
                Карточка задачи
            </div>
            <div class="actions">
                <div class="btn btn-default orange action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </div>
                <div class="btn btn-default grey action-close" @click="close">
                    закрыть
                </div>
            </div>
        </div>
        <div class="tasks-wrapper mobile-wrapper">
            <div class="card task-main-info">
                <div class="row task-item-row task-item-id title">
                    <div class="label">
                        ID:
                    </div>
                    <div class="value">
                        {{ task.id }}
                    </div>
                </div>
                <div class="row task-item-row task-item-title title">
                    {{ task.title }}
                </div>
                <div class="row task-item-row task-item-status">
                    <div class="label">
                        Статус:
                    </div>
                    <div class="value">
                        {{ statusName }}
                    </div>
                </div>
                <div class="row task-item-row task-item-status">
                    <div class="label">
                        Приоритет:
                    </div>
                    <div :class="[priorityColor, 'value']">
                        {{ priorityName }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Дата-время создания:
                    </div>
                    <div class="value">
                        {{ task.created_at }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Выполнить до:
                    </div>
                    <div class="value">
                        {{ task.planned }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Сделка или лид:
                    </div>
                    <template>
                        <div class="link value" @click="goRelatedEntity()" v-if="issetRelatedEntity">
                            {{ task.related_entity_id }}
                        </div>
                    </template>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Постановщик:
                    </div>
                    <div class="value">
                        {{ createdUserName }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Исполнитель:
                    </div>
                    <div class="value">
                        {{ assignedUserName }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Дата завершения:
                    </div>
                    <div class="value">
                        {{ task.finished }}
                    </div>
                </div>
                <div class="row task-item-row">
                    <div class="label">
                        Файлы:
                    </div>
                    <div class="files-list">
                        <el-tag
                            v-for="file in task.files"
                            :key="file.id"
                            :type="''"
                            size="mini"
                            class="pointer ellipsis"
                            @click.native="handleTagClick(file)"
                            :disable-transitions="true"
                        >
                            {{ file.name }}
                        </el-tag>
                    </div>
                </div>
            </div>
            <div class="card task-comment">
                <div class="row task-item-row">
                    <div class="label">
                        Комментарии:
                    </div>
                </div>
                <div class="row task-item-row task-item-comment" v-if="task.commentaries">
                    <div class="task-comments">
                        <div
                            v-for="commentDate in Object.keys(task.commentaries)"
                            :key="commentDate"
                            class="day"
                        >
                            <div class="title-date">
                                {{ getCommentDate(commentDate) }}
                            </div>
                            <div
                                v-for="comment in task.commentaries[commentDate]"
                                :key="comment.id"
                            >
                                <div class="comment">
                                    <span class="name">
                                        {{ comment.employer ? comment.employer.full_name : 'неизвестен' }}
                                    </span>
                                    <span class="time">
                                        {{ comment.created_time }}
                                    </span>
                                </div>
                                <div class="text" v-html="prepareText(comment.text)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from './Card';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

library.add(faCheck);

export default {
    name: 'TasksCardMobile',
    extends: Card
};
</script>
